// extracted by mini-css-extract-plugin
export default {"priceRating":"index_priceRating__3_MU7","fadedPrice":"index_fadedPrice__1G0dT"};